/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { TransportType } from './TransportType';
import {
    TransportTypeFromJSON,
    TransportTypeFromJSONTyped,
    TransportTypeToJSON,
    TransportTypeToJSONTyped,
} from './TransportType';

/**
 * 
 * @export
 * @interface ResponseTransportType
 */
export interface ResponseTransportType {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseTransportType
     */
    result: ResponseResult;
    /**
     * 
     * @type {TransportType}
     * @memberof ResponseTransportType
     */
    data: TransportType;
}

/**
 * Check if a given object implements the ResponseTransportType interface.
 */
export function instanceOfResponseTransportType(value: object): value is ResponseTransportType {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseTransportTypeFromJSON(json: any): ResponseTransportType {
    return ResponseTransportTypeFromJSONTyped(json, false);
}

export function ResponseTransportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseTransportType {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': TransportTypeFromJSON(json['data']),
    };
}

export function ResponseTransportTypeToJSON(json: any): ResponseTransportType {
    return ResponseTransportTypeToJSONTyped(json, false);
}

export function ResponseTransportTypeToJSONTyped(value?: ResponseTransportType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': TransportTypeToJSON(value['data']),
    };
}

